import { createAsyncThunk } from "@reduxjs/toolkit";

import { getRecommendations } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchRecommendations = createAsyncThunk(
  "recommendations/fetchRecommendations",
  async (params: { query?: any }, { getState, rejectWithValue }) => {
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const { query } = params;

      const response = await getRecommendations(token, baseUrl, {
        filterable: true,
        per_page: 5,
        page: 1,
        filters: { sort: { created_at: "desc" } },
        ...query
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
